export default __webpack_public_path__ + "static/media/logo.3de08f36.png";